import type { SiteStatus } from "@crewledger/shared/schemas";
import { cn } from "@/lib/utils";

const STYLES: Record<SiteStatus, string> = {
  ACTIVE: "bg-green-50 text-green-700 border-green-200",
  INACTIVE: "bg-slate-100 text-slate-600 border-slate-200",
  CLOSED: "bg-navy-deep/5 text-navy-deep border-navy-deep/20",
};

const LABELS: Record<SiteStatus, string> = {
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  CLOSED: "Archived",
};

interface SiteStatusBadgeProps {
  status: SiteStatus;
  className?: string;
}

export function SiteStatusBadge({ status, className }: SiteStatusBadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex rounded-full border px-2.5 py-0.5 text-xs font-semibold",
        STYLES[status],
        className,
      )}
    >
      {LABELS[status]}
    </span>
  );
}
